module.exports = isHook

function isHook(hook) {
    return hook && typeof hook.hook === "function" &&
        !hook.hasOwnProperty("hook")
}



//////////////////
// WEBPACK FOOTER
// ./~/virtual-hyperscript/~/vtree/is-vhook.js
// module id = 68
// module chunks = 0